import _default from './Step';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Step/index.js
// module id = 2828
// module chunks = 0